// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"J1T0rBCh87SVaW6ZcO6r"};